export function getLegacyAddressVerifyAPI({
  address,
  countryValue,
  countryComparisonFlag = "T",
  isUSA
}) {
  const trimmedAddress = (address || "").trim();
  const trimmedCountry = (countryValue || "").trim();
  const trimmedFlag = (countryComparisonFlag || "T").trim();

  return isUSA
    ? `${
        window.PUBLIC_ENV.CONSOLIDATION_PREFIX
      }/api/addressVerify?address=${encodeURIComponent(trimmedAddress)}`
    : `${
        window.PUBLIC_ENV.CONSOLIDATION_PREFIX
      }/api/intladdressverify?address=${encodeURIComponent(
        trimmedAddress
      )}&ISO3=${encodeURIComponent(
        trimmedCountry
      )}&countryComparisonFlag=${encodeURIComponent(trimmedFlag)}`;
}

export default function createLegacyAddressProvider({
  component,
  getIsUSA,
  getIsValidateCountry,
  setAutocompleteResponse,
  setAddressVerifyResponse
}) {
  return {
    getAutocompleteAPI(countryValue) {
      return getIsUSA()
        ? `${
            window.PUBLIC_ENV.CONSOLIDATION_PREFIX
          }/api/autocomplete?address=${encodeURIComponent(
            component.addrField.value
          )}`
        : `${
            window.PUBLIC_ENV.CONSOLIDATION_PREFIX
          }/api/intlautocomplete?address=${encodeURIComponent(
            component.addrField.value
          )}&country=${encodeURIComponent(countryValue)}`;
    },

    getAddressVerifyAPI(address, countryValue, countryComparisonFlag) {
      return getLegacyAddressVerifyAPI({
        address,
        countryValue,
        countryComparisonFlag,
        isUSA: getIsUSA()
      });
    },

    getUSZip(addr) {
      return new Promise((resolve) => {
        const req = new XMLHttpRequest();
        req.addEventListener("load", () => {
          if (req.status === 200) {
            const candidates = req.response;
            if (Array.isArray(candidates) && candidates?.length > 0) {
              resolve(candidates[0]?.components?.["zipcode"] || "");
            } else {
              resolve("");
            }
          } else {
            resolve("");
          }
        });
        const api = this.getAddressVerifyAPI(addr);
        req.open("POST", api);
        req.responseType = "json";
        req.send();
      });
    },

    autocompleteEndpoint(countryValue) {
      const req = new XMLHttpRequest();
      const autocompleteAPI = this.getAutocompleteAPI(countryValue);

      req.addEventListener("load", () => {
        if (req.status === 200) {
          const options = getIsUSA() ? req?.response : req?.response?.Output;
          if (!getIsUSA() && getIsValidateCountry()) {
            setAutocompleteResponse(req?.response);
          }
          component.autocompleteOptions.forEach(
            (option) => (option.hidden = true)
          );
          const noOptions = getIsUSA()
            ? options?.length === 0
            : !options?.some((address) => address?.FormattedAddress);
          component.emptyStrikes = noOptions ? component.emptyStrikes + 1 : 0;
          for (let i = 0; i < 10 && i < options?.length; i++) {
            if (
              (!getIsUSA() &&
                options[i]?.FormattedAddress?.length > 0 &&
                options[i]?.Status !== "F") ||
              getIsUSA()
            ) {
              const address = getIsUSA()
                ? options[i]?.text
                : options[i]?.FormattedAddress;
              if (component.autocompleteOptions[i]) {
                component.autocompleteOptions[i].innerText = address;
                component.autocompleteOptions[i].hidden = false;
                component.autocompleteOptions[i].data = options[i];
              }
              if (component.noAutocompleteOption) {
                component.noAutocompleteOption.hidden = true;
              }
            }
          }
        } else {
          component.autocompleteOptions.forEach(
            (option) => (option.hidden = true)
          );
          if (component.noAutocompleteOption) {
            component.noAutocompleteOption.hidden = false;
          }
        }
        if (component.autocompleteArea) {
          component.autocompleteArea.hidden = false;
        }
      });
      req.open("GET", autocompleteAPI);
      req.responseType = "json";
      req.send();
    },

    getUSAutocompleteSuggestions() {
      return new Promise((resolve) => {
        const api = this.getAutocompleteAPI();
        const req = new XMLHttpRequest();
        req.addEventListener("load", () => {
          if (req.status === 200 && Array.isArray(req.response)) {
            const enhanced = req.response.map((obj) => ({
              ...obj,
              country: "United States",
              source: "autocomplete"
            }));
            resolve(enhanced);
          } else {
            resolve([]);
          }
        });
        req.open("GET", api);
        req.responseType = "json";
        req.send();
      });
    },

    intlAddressVerify(addr, countryComparisonFlag) {
      return new Promise((resolve) => {
        const api = this.getAddressVerifyAPI(
          addr,
          component.hiddenAddressCountryISO3.value,
          countryComparisonFlag
        );
        const req = new XMLHttpRequest();
        req.addEventListener("load", () => {
          setAddressVerifyResponse(req.response);
          component.setPreciselyFields();
          resolve(req.response);
        });
        req.addEventListener("error", () => resolve());
        req.addEventListener("abort", () => resolve());
        req.open("POST", api);
        req.responseType = "json";
        req.send();
      });
    },

    fetchPreciselyIK() {
      const api = `${window.PUBLIC_ENV.CONSOLIDATION_PREFIX}/api/preciselyik`;
      const req = new XMLHttpRequest();
      req.addEventListener("load", () => {
        component.preciselyIK.value = "true";
      });
      req.open("GET", api);
      req.responseType = "json";
      req.send();
    }
  };
}
